"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSearchSuggestionsEndpointRequest = void 0;
const ProductWith_1 = require("../../types/ProductWith");
function suggetionsWithQueryParameter(suggestionsWith) {
    const withParams = [];
    if (suggestionsWith.products &&
        typeof suggestionsWith.products === 'object') {
        withParams.push(...(0, ProductWith_1.productWithQueryParameterValues)(suggestionsWith.products).map(value => `products.${value}`));
    }
    return withParams;
}
function createSearchSuggestionsEndpointRequest(parameters) {
    const topLevelIncludes = [];
    if (parameters.with) {
        if (parameters.with.brands) {
            topLevelIncludes.push('brands');
        }
        if (parameters.with.categories) {
            topLevelIncludes.push('categories');
        }
        if (parameters.with.productNames) {
            topLevelIncludes.push('productNames');
        }
        if (parameters.with.products) {
            topLevelIncludes.push('products');
        }
    }
    return {
        method: 'GET',
        endpoint: `search/suggestions`,
        params: Object.assign(Object.assign({ term: parameters.term }, (parameters.campaignKey
            ? { campaignKey: parameters.campaignKey }
            : undefined)), { with: [
                topLevelIncludes,
                ...(parameters.with
                    ? suggetionsWithQueryParameter(parameters.with)
                    : []),
            ].join(`,`) }),
    };
}
exports.createSearchSuggestionsEndpointRequest = createSearchSuggestionsEndpointRequest;
